import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-pg-msc',
  templateUrl: './pg-msc.component.html',
  styleUrls: ['./pg-msc.component.scss']
})
export class PgMscComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
